import App from './App.vue'
import BaseApp from '../BaseApp.vue'

BaseApp.methods.mountApp(App);